module.exports = __webpack_public_path__ + "pc/img/logo.ca40c7d6.png";